namespace Customer
{
	export namespace data
	{

		export class CustomerTableDataModel
			extends ui.table.model.AbstractTableModel<Wollmilch.CustomerObject>
		{

			public constructor( company: Wollmilch.CompanyObject, descriptor?: ui.table.model.ITableModelDescriptor )
			{
				super( descriptor );

				this.ModelReader( new CustomerTableDataReader( company ) );
			}

			public buildHeader(): JQuery<HTMLElement>
			{
				return new ui.base.BaseHTMLElement( 'tr' )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( 'Kundennummer' ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( 'Name' ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( 'Erstellt am' ) )
				.Root();
			}

		}

		export class CustomerTableDataReader
			extends ui.table.DataReader< Wollmilch.CustomerObject >
		{
			private m_Company: Wollmilch.CompanyObject;

			public constructor( company: Wollmilch.CompanyObject )
			{
				super();

				this.m_Company	= company;
			}

			public GenerateDataField( p_Data: Wollmilch.CustomerObject ): JQuery<HTMLElement>
			{
				const customer = new Wollmilch.Customer( this.m_Company, p_Data );
				const link = $(
					new Button(
						{
							title: customer.CustomerNumber(),
							style: 'link',
							on:
							{
								click: () =>
								{
									app.getGlobalTabControl().addTab(
										customer.Customer().Name,
										new Page( this.m_Company, p_Data ),
										true
									);
								}
							}
						}
					).getElement()
				).removeClass( 'btn' );

				return new ui.base.BaseHTMLElement( 'tr' )
					.append(
						new ui.base.BaseHTMLElement( 'td' ).append( link )
					)
					.append(
						new ui.base.BaseHTMLElement( 'td' ).append( p_Data.Name )
					)
					.append(
						new ui.base.BaseHTMLElement( 'td' ).append( new Date( p_Data.Customer.CreatedAt || new Date().getTime().toString() ).pattern( 'd.m.Y' ) )
					)
				.Root();
			}
		}

		export class CustomerCardDataModel
		extends ui.table.model.AbstractCardModel<Wollmilch.CustomerObject>
	{

		public constructor( company: Wollmilch.CompanyObject, descriptor?: ui.table.model.ICardModelDescriptor )
		{
			super( descriptor );

			this.ModelReader( new CustomerCardDataReader( company ) );
		}

	}

	 export class CustomerCardDataReader
		extends ui.table.DataReader< Wollmilch.CustomerObject >
	{
		private m_Company: Wollmilch.CompanyObject;

		public constructor( company: Wollmilch.CompanyObject )
		{
			super();

			this.m_Company	= company;
		}

		public GenerateDataField( p_Data: Wollmilch.CustomerObject ): JQuery<HTMLElement>
		{
			const customer = new Wollmilch.Customer( this.m_Company, p_Data );
			const link = $(
				new Button(
					{
						title: customer.CustomerNumber(),
						style: 'link',
						on:
						{
							click: () =>
							{
								app.getGlobalTabControl().addTab(
									p_Data.Name,
									new Page( this.m_Company, p_Data ),
									true
								);
							}
						}
					}
				).getElement()
			).removeClass( 'btn' );

			return new ui.base.BaseHTMLElement( 'card' ).css( 'text-align', 'center' )
				.append( new ui.base.BaseHTMLElement( 'p' ).append( link ) )
				.append( new ui.base.BaseHTMLElement( 'p' ).append( p_Data.Name ) )
				.append( new ui.base.BaseHTMLElement( 'p' ).append( new Date( p_Data.Customer.CreatedAt || new Date().getTime().toString() ).pattern( 'd.m.Y' ) ) )
			.Root();
		}
	}

	}
}
